import {useState} from "react";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import VLFModal from "@/components/Modal";
import MainActions from "@/components/MainActions";
import VLFSelectNew from "@/components/Input/SelectNew";

export default function ResultStatus({result, onChoose, canEdit}) {
	const [comparison, setComparison] = useState(null);
	const [source, setSource] = useState("");
	const [saving, setSaving] = useState(false);
	if (!result) return null;
	const labels = {
		events: "Risultato calcolato dai goal della cronaca",
		manual: "Risultato inserito a mano",
		conflict: "Il risultato non coincide con i goal della cronaca",
		uncollected: "Risultato da inserire",
	};
	const sourceOptions = [
		{value: "events", label: "Dai goal della cronaca"},
		{
			value: "manual",
			label: "Inserito a mano",
			isDisabled:
				comparison?.manualHome == null || comparison?.manualAway == null,
		},
	];
	const comparable =
		result.eventHome != null &&
		result.eventAway != null &&
		(result.manualHome != null || result.manualAway != null);
	return (
		<div className="col-12 padding-small">
			<div className="d-flex justify-content-between align-items-center flex-wrap gap-2 border-top pt-2">
				<span>
					{labels[result.source]}
					{result.warning && (
						<small className="d-block text-warning">{result.warning}</small>
					)}
				</span>
				{comparable && (
					<MainActions
						actions={[
							{
								icon: <CompareArrowsIcon />,
								title: "Confronta risultato",
								disabled: !canEdit,
								onClick: () => {
									setComparison(result);
									setSource(result.conflict ? "" : result.source);
								},
							},
						]}
					/>
				)}
			</div>
			<VLFModal
				open={!!comparison}
				title="Confronta risultato"
				close={() => !saving && setComparison(null)}
				disabled={saving || !source}
				confirmLabel="Conferma"
				confirm={async () => {
					setSaving(true);
					try {
						if (await onChoose(source, comparison)) setComparison(null);
					} finally {
						setSaving(false);
					}
				}}
				content={
					<>
						<p>
							Il risultato inserito a mano resta salvato. Scegliendo la cronaca,
							il punteggio si aggiorna con i goal.
						</p>
						<table className="table">
							<thead>
								<tr>
									<th></th>
									<th>Casa</th>
									<th>Trasferta</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Inserito a mano</td>
									<td>{comparison?.manualHome ?? "-"}</td>
									<td>{comparison?.manualAway ?? "-"}</td>
								</tr>
								<tr>
									<td>Dai goal della cronaca</td>
									<td>{comparison?.eventHome ?? "-"}</td>
									<td>{comparison?.eventAway ?? "-"}</td>
								</tr>
							</tbody>
						</table>
						<VLFSelectNew
							label="Risultato da tenere"
							aria-label="Risultato da tenere"
							options={sourceOptions}
							value={sourceOptions.find((o) => o.value === source) || null}
							onChange={(option) => setSource(option?.value || "")}
							sorted={false}
							isClearable={false}
						/>
					</>
				}
			/>
		</div>
	);
}
